import React from "react";
import { FONT_SIZES } from "../../styles";

const Contact = () => {
  return (
    <div style={{ minHeight: "20rem", fontSize: FONT_SIZES.s }}>
      <a href="mailto:nicholascsward@gmail.com" style={{ display: "inline" }}>
        {"Please email me"}
      </a>{" "}
      if you'd like to chat about job opportunities, volunteering, career
      switching into tech, or working at Google.
    </div>
  );
};

export default Contact;
